module.exports = __webpack_public_path__ + "static/media/compBg.69c9d622.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/compBg.jpg
// module id = 1947
// module chunks = 0